// extracted by mini-css-extract-plugin
module.exports = {"anchor":"MainMenuItem_anchor","icon":"MainMenuItem_icon","label":"MainMenuItem_label","linkContainer":"MainMenuItem_linkContainer"};